// extracted by mini-css-extract-plugin
export default {"pageLoading":"page-loading_pageLoading__2NWra"};